

import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class BranchMap extends kr.Component {
    init()
    {
        this.map = null;
        this.mapEl = this.$element.querySelector('.js-branchesMapContent');
        this.items = this.$element.querySelectorAll('.js-branchesMapItem');
        this.mapMarkersLatLng = [];
        this.mapMarkers = [];

        this.app.addJs('https://unpkg.com/leaflet@1.7.1/dist/leaflet.js', true, this._callback.bind(this));
        this.app.addCss('https://unpkg.com/leaflet@1.7.1/dist/leaflet.css');
    }

    bind()
    {
        this.map = window.L.map(this.mapEl, {
            //center: [this.lat, this.lng],
            zoom: 2
        });
        L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
            maxZoom: 18
        })
        .addTo(this.map);

        this.items.forEach(item => {
            this._addMarker(item);
        });

        const bounds = new L.LatLngBounds(this.mapMarkersLatLng);
        this.map.fitBounds(bounds, {
            maxZoom: 3
        });
    }


    _addMarker(item)
    {
        const lat = item.getAttribute('data-map-lat');
        const lng = item.getAttribute('data-map-lng');
        const marker = L.marker([lat, lng]).addTo(this.map);
        marker.bindPopup(item.innerHTML);
        this.mapMarkers.push(marker);
        this.mapMarkersLatLng.push([lat, lng]);
    }

    _callback()
    {
        this.bind();
    }

}

kr.registerComponent('.js-branchsMap', {
    component: BranchMap
});
